module.exports = __webpack_public_path__ + "static/img/index4(1)_06.cea1e23.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index4(1)_06.png
// module id = 3131
// module chunks = 1